import { preFormat, postFormat } from './file-with-type'
//------------------------------------------------
// Image field formatter
//------------------------------------------------
export default {
  type: 'Video',
  preFormat: (fieldValues, Type) => {
    return preFormat(fieldValues, Type, 'Video')
  },
  postFormat: (fieldValues, Type) => {
    return postFormat(fieldValues, Type, 'Video')
  },
}
